export async function createPhaserGame({ createConfig, parent }) {
  if (process.env.NODE_ENV === 'test') {
    return {
      destroy() {},
    };
  }

  const { default: Phaser } = await import('phaser');
  const config = createConfig({ Phaser, parent }) ?? {};

  return new Phaser.Game({
    ...config,
    parent,
  });
}
